<template>
    <UserMenu
        v-if="user"
        :name="userName"
        :email="userName === userEmail ? null : userEmail"
        :avatar-url="userAvatar"
    >
        <Menu spaced>
            <slot />
            <MenuLink label="Log out" @click="logOut" />
        </Menu>
    </UserMenu>
</template>

<script lang="ts">
    import { Component, Vue } from '@evidentid/vue-property-decorator';

    import { Menu, MenuLink } from '../../../components/Menu';
    import { UserMenu } from '../../../components/UserMenu';
    import { useUserStore } from '../store/user';
    import { UserState } from '../types';

    @Component({
        components: { Menu, MenuLink, UserMenu },
    })
    export default class UserBox extends Vue {
        private get user(): UserState['data'] {
            return useUserStore().data;
        }

        private get userName() {
            return this.user?.displayName || this.userEmail;
        }

        private get userEmail() {
            return this.user?.email;
        }

        private get userAvatar() {
            return this.user?.photoURL;
        }

        private logOut() {
            useUserStore().logOut();
        }
    }
</script>
